function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Box, Loading, SectionSpacer, Typography } from '@applyboard/ui-components';
import { ButtonLink, Flex } from '@applyboard/crystal-ui';
import { verifyRole, UserContext, useEventTracker } from '@applyboard/ui-utils';
import { ProgramCard } from '@applyboard/business-ui-legacy';
import { SimplifiedCheckEligibilityButton, SimplifiedCheckEligibilityModal, useSimplifiedSchoolEligibilityApi } from '@applyboard/dsj-ui';
import { AppContext } from "../../context";
import { useSimilarPrograms } from "../../data";
import { getProgramsProps } from "./util";
import { SimilarProgramsTitle } from "./SimilarProgramsTitle";
function ErrorLabel() {
  return /*#__PURE__*/React.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Sorry, we couldn't find any similar programs. Please click the Explore more programs below to find similar programs using Search."));
}
function SimilarProgram(_ref) {
  var _appContext$program, _appContext$initialPr, _appContext$initialPr2;
  var program = _ref.program,
    onCheckEligibility = _ref.onCheckEligibility,
    onClickCard = _ref.onClickCard;
  var appContext = useContext(AppContext);
  var eligibilities = useSimplifiedSchoolEligibilityApi(appContext.dsjState, [program.id], program.schoolId);
  var onClick = useCallback(function () {
    return onCheckEligibility(program.id);
  }, [program.id, onCheckEligibility]);
  return /*#__PURE__*/React.createElement(ProgramCard, {
    onCheckEligibility: onCheckEligibility,
    program: program,
    onClickCard: onClickCard,
    showIcon: false
  }, appContext.hideEligibility ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(SimplifiedCheckEligibilityButton, {
    eligibility: eligibilities[program.id],
    variant: "outlined",
    programId: program.id,
    programName: program.name,
    programLevel: (_appContext$program = appContext.program) === null || _appContext$program === void 0 ? void 0 : _appContext$program.level,
    schoolId: program.schoolId,
    schoolCountry: (_appContext$initialPr = appContext.initialProps) === null || _appContext$initialPr === void 0 ? void 0 : _appContext$initialPr.country.name,
    onClick: onClick,
    eventTrackingPrefix: "Programs Page",
    featureFlags: (_appContext$initialPr2 = appContext.initialProps) === null || _appContext$initialPr2 === void 0 ? void 0 : _appContext$initialPr2.featureFlags
  }));
}
function ExploreMoreProgramsButton(_ref2) {
  var searchUrl = _ref2.searchUrl;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "end",
    justify: "end"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    "aria-label": "Explore more programs",
    emphasis: "contained",
    href: searchUrl,
    intent: "primary",
    size: "md"
  }, "Explore more programs")));
}
export function SimilarPrograms(_ref3) {
  var program = _ref3.program,
    searchUrl = _ref3.searchUrl;
  var sourcePageProgramId = program.id,
    sourcePageProgramName = program.name,
    sourcePageSchoolId = program.schoolId,
    sourcePageSchoolName = program.schoolName;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    checkEligibilityProgramId = _useState2[0],
    setCheckEligibilityProgramId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    checkEligibilityModalOpen = _useState4[0],
    setCheckEligibilityModalOpen = _useState4[1];
  var currentUser = useContext(UserContext);
  var appContext = useContext(AppContext);
  var onCheckEligibilityModalClose = useCallback(function () {
    setCheckEligibilityModalOpen(false);
  }, [setCheckEligibilityModalOpen]);
  var onClickCheckEligibility = useCallback(function (programId) {
    setCheckEligibilityProgramId(programId);
    setCheckEligibilityModalOpen(true);
  }, [setCheckEligibilityModalOpen, setCheckEligibilityProgramId]);
  var trackProgramClickedEvent = useCallback(function (clickedProgram, clickedProgramIndex, displayedSimilarPrograms) {
    trackEvent({
      event: 'Programs Page - Clicked Similar Program',
      data: {
        spId: clickedProgram.id,
        spName: clickedProgram.name,
        spSchoolId: clickedProgram.schoolId,
        spSchoolName: clickedProgram.schoolName,
        spIndex: clickedProgramIndex,
        spList: displayedSimilarPrograms === null || displayedSimilarPrograms === void 0 ? void 0 : displayedSimilarPrograms.map(function (sp, index) {
          return {
            index: index,
            spId: sp.id,
            spName: sp.name,
            spSchoolId: sp.schoolId,
            spSchoolName: sp.schoolName
          };
        }),
        spListCount: (displayedSimilarPrograms === null || displayedSimilarPrograms === void 0 ? void 0 : displayedSimilarPrograms.length) || 0,
        sourcePageProgramId: sourcePageProgramId,
        sourcePageProgramName: sourcePageProgramName,
        sourcePageSchoolId: sourcePageSchoolId,
        sourcePageSchoolName: sourcePageSchoolName
      }
    });
  }, [trackEvent, sourcePageProgramId, sourcePageProgramName, sourcePageSchoolId, sourcePageSchoolName]);
  var _useSimilarPrograms = useSimilarPrograms(sourcePageProgramId),
    similarPrograms = _useSimilarPrograms.similarPrograms,
    isFetchSimilarProgramsSuccessful = _useSimilarPrograms.isFetchSimilarProgramsSuccessful,
    isLoadingSimilarPrograms = _useSimilarPrograms.isLoadingSimilarPrograms;
  var similarProgramProps = useMemo(function () {
    return similarPrograms ? getProgramsProps(similarPrograms, verifyRole.isInternalStaff(currentUser)) : null;
  }, [!!similarPrograms]);
  var similarProgramsCount = !isFetchSimilarProgramsSuccessful ? null : similarProgramProps === null || similarProgramProps === void 0 ? void 0 : similarProgramProps.length;
  useEffect(function () {
    if (!similarProgramProps) {
      return;
    }
    trackEvent({
      event: 'Programs Page - Displayed Similar Programs',
      data: {
        similarPrograms: similarProgramProps === null || similarProgramProps === void 0 ? void 0 : similarProgramProps.map(function (sp, index) {
          return {
            index: index,
            spId: sp.id,
            spName: sp.name,
            spSchoolId: sp.schoolId,
            spSchoolName: sp.schoolName
          };
        }),
        similarProgramsCount: (similarProgramProps === null || similarProgramProps === void 0 ? void 0 : similarProgramProps.length) || 0,
        sourcePageProgramId: sourcePageProgramId,
        sourcePageProgramName: sourcePageProgramName,
        sourcePageSchoolId: sourcePageSchoolId,
        sourcePageSchoolName: sourcePageSchoolName
      }
    });
  }, [similarProgramProps]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SimplifiedCheckEligibilityModal, {
    programId: checkEligibilityProgramId,
    open: checkEligibilityModalOpen,
    onClose: onCheckEligibilityModalClose,
    setDsjState: appContext.setDsjState
  }), /*#__PURE__*/React.createElement(SectionSpacer, null, /*#__PURE__*/React.createElement(SimilarProgramsTitle, null), isLoadingSimilarPrograms && /*#__PURE__*/React.createElement(Loading, null), !isLoadingSimilarPrograms && (!isFetchSimilarProgramsSuccessful || similarProgramsCount === 0) && /*#__PURE__*/React.createElement(ErrorLabel, null), similarProgramProps && similarProgramProps.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SimilarProgram, {
      onCheckEligibility: onClickCheckEligibility,
      key: item.id,
      program: item,
      onClickCard: function onClickCard() {
        return trackProgramClickedEvent(item, index, similarProgramProps);
      }
    });
  })), !isLoadingSimilarPrograms && /*#__PURE__*/React.createElement(ExploreMoreProgramsButton, {
    searchUrl: searchUrl
  }));
}